import React from "react";
import useOutbox from "../../hooks/useOutbox";
import { formatTime } from "../../utils/helpers";

/**
 * Banner antrean absen. Tampil selama ada absen yang tersimpan di HP dan belum
 * terkirim (mis. sinyal lemah), atau yang ditolak server. Sengaja `sticky` seperti
 * ConnectionBanner (bukan `fixed`) supaya tetap di dalam kolom app.
 */
export default function OutboxBanner() {
  const { pending, failed, justSent, sending, flushNow, dismiss } = useOutbox();

  if (!pending.length && !failed.length && !justSent) return null;

  return (
    <div className="sticky top-0 z-40 w-full">
      {failed.map((item) => (
        <div key={item.id} className="border-b border-red-100 bg-red-50 px-3.5 py-2.5 text-red-800">
          <div className="mx-auto flex max-w-[430px] items-start gap-2.5">
            <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-red-500" />
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-black uppercase tracking-wider">
                Absen {item.type === "in" ? "masuk" : "pulang"} {formatTime(item.capturedAt)} tidak terkirim
              </p>
              <p className="mt-0.5 break-words text-[11px] font-semibold leading-snug">{item.lastError}</p>
            </div>
            <button type="button" onClick={() => dismiss(item.id)} className="shrink-0 text-[11px] font-black underline">
              Tutup
            </button>
          </div>
        </div>
      ))}

      {pending.length > 0 && (
        <div className="border-b border-amber-100 bg-amber-50 px-3.5 py-2.5 text-amber-900">
          <div className="mx-auto flex max-w-[430px] items-start gap-2.5">
            <span className="mt-1 h-2 w-2 shrink-0 animate-pulse rounded-full bg-amber-500" />
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-black uppercase tracking-wider">
                {pending.length} absen menunggu dikirim
              </p>
              <p className="mt-0.5 break-words text-[11px] font-semibold leading-snug">
                Absen kamu sudah tersimpan di HP (jam {formatTime(pending[0].capturedAt)}). Akan dikirim otomatis
                saat koneksi pulih — jaga app tetap terbuka atau buka lagi nanti.
              </p>
            </div>
            <button
              type="button"
              onClick={flushNow}
              disabled={sending}
              className="shrink-0 text-[11px] font-black underline disabled:opacity-50"
            >
              {sending ? "Mengirim..." : "Kirim sekarang"}
            </button>
          </div>
        </div>
      )}

      {pending.length === 0 && justSent > 0 && (
        <div className="border-b border-green-100 bg-green-50 px-3.5 py-2 text-green-800">
          <p className="mx-auto max-w-[430px] text-[11px] font-black uppercase tracking-wider">
            ✓ {justSent} absen tertunda berhasil terkirim
          </p>
        </div>
      )}
    </div>
  );
}
